export default __webpack_public_path__ + "static/media/MainLogo.03c62673.svg";